import { render, staticRenderFns } from "./editcollectormodel.vue?vue&type=template&id=717190d2&"
import script from "./editcollectormodel.vue?vue&type=script&lang=ts&"
export * from "./editcollectormodel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editcollectormodel.vue"
export default component.exports